import { useEffect } from 'react';
import type { JSX } from 'react';

import type { StepState } from 'src/app/pages/startAPetition/pageContext';
import { useStepState } from 'src/app/pages/startAPetition/pageContext';

import { SkipStep } from '../../SkipStep';

import { LocationLoader } from './LocationLoader';

export function LocationWrapper(): JSX.Element {
	const { data, actions } = useStepState();

	// conditions
	const isLocalPetition = (currentPetition: StepState['petition']) => currentPetition?.geoReach === 'local';
	const shouldSkipStep = !isLocalPetition(data.petition);

	// TODO: add this as `onSkip` prop to `SkipStep` component?
	useEffect(() => {
		if (shouldSkipStep) {
			actions.updatePetition({ location: null });
		}
	}, [actions, shouldSkipStep]);

	return shouldSkipStep ? <SkipStep /> : <LocationLoader />;
}
